import { type UUID } from '~/types/common';

import { map, pipe } from '@vestigas/utils';
import { oldestFirst } from '~/utils';

import { type AssetChain } from '../../useQueryDeliveryNoteChainsAdmin';

/**
 * Calculate the version of an asset chain among all asset chains. Starts at 1.
 * @param assetChains - The list of all asset chains.
 * @param currentAssetChainId - The ID of the current asset chain.
 * @returns The version of the current asset chain.
 */
export const getAssetChainVersion = (
  assetChains: AssetChain[],
  currentAssetChainId: UUID,
) => {
  if (
    !assetChains?.length ||
    !currentAssetChainId ||
    typeof currentAssetChainId !== 'string'
  ) {
    return undefined;
  }

  const versionIndex = pipe(
    [...assetChains],
    (assetChains) => oldestFirst(assetChains, 'createdOn'),
    map(({ id }) => id),
    (assetChains) => assetChains.indexOf(currentAssetChainId),
  );

  if (versionIndex === -1) {
    return undefined;
  }

  const version = versionIndex + 1;

  return version;
};
